// Clients will provide vimeo link.
// If vimeo link is https://vimeo.com/557230853/dcf7836b65
// then the vimeoId is 557230853, not the dcf..

export interface onDemandVideosType {
  vimeoId: string
  title: string
  thumbnail?: string
  /**
   * can be react routes, ie. /booths/1, /lobby
   * or external link, ie. https://something.com, mailto:hello@email.com
   */
  buttonUrl?: string
  buttonText?: string
}

const virtualProductTheatreVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '717810009?h=6b67755570',
    title: 'An Expert Opinion by Prof Felicia Cosman',
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vpt-01.jpg',
  },
  {
    vimeoId: '717810289?h=4000c648b3',
    title: 'EVENITY',
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vpt-02.jpg',
  },
  {
    vimeoId: '717810694?h=e8f4d47017',
    title: 'ROW BIOFILM & AQUACEL Ag+ Extra COMBINED Mode Of Action Animation',
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vpt-03.jpg',
  },
  {
    vimeoId: '717811243?h=f424232d55',
    title: "AQUACEL Surgical post-op dressing application on a knee",
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vpt-04.jpg',
  },
  {
    vimeoId: '717811312?h=4b7254cf03',
    title: 'AG Foam',
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vpt-05.jpg',
  },
  {
    vimeoId: '717811800?h=bb10e8fa8b',
    title: 'Postoperative Pain Management (Dynastat) and Anti-infectives (Zinforo & Tazocin)',
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vpt-06.jpg',
    buttonUrl: '/booths/3',
    buttonText: 'Visit Booth',
  },
]

const onDemandSymposiumsVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '717813506?h=3c211e3d94',
    title: 'Perioperative Pain Management in Spine Surgery: What should be in the mix? by Prof Dr Sabarul Mokthar',
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vss-01.jpg',
    buttonUrl:'/booths/3',
    buttonText: 'Visit Booth'
  },
  {
    vimeoId: '717813690?h=3c68177ab4',
    title: 'The Dilemma of VTE Prophylaxis in Orthopaedic Surgery by Dr Liew Ngoh Chin',
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vss-02.jpg',
    buttonUrl: '/booths/3',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '717813825?h=9edbf97d3d',
    title: 'Updates on the management of osteoarthritis, from ESCEO to Malaysian Consensus by Prof Bruyere Dr Tai Cheh Chin',
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vss-03.jpg',
    buttonUrl: '/booths/4',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '719295024?h=1edc827ca5',
    title: 'BEYOND THE BREAK IN THE BONE - Osteoporosis & the fracture in-waiting',
    thumbnail: 'https://moa-2022.s3.ap-southeast-1.amazonaws.com/vss-04.jpg',
    buttonUrl: '/booths/1',
    buttonText: 'Visit Booth',
  },
]

export {
  virtualProductTheatreVideos,
  onDemandSymposiumsVideos,
}
